export default function match<Item>(item: Item) {
  return <Value>(
    conditionsAndValues: [(item: Item) => boolean, Value][],
  ): Value | undefined => conditionsAndValues.find(([condition]) => condition(item))?.[1]
}
